import { TFunction } from "i18next";

export const parseBoolToString = (value: boolean, t: TFunction) => (value ? t("yes") : t("no"));
